module.exports = __webpack_public_path__ + "static/media/johnson-wang-515975-unsplash.beebb468.jpg";